module.exports = __webpack_public_path__ + "3b16aa20cb6b5a296a883ec2bc1a6502.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-bolditalic/opensans-bolditalic.ttf
// module id = ./src/styles/fonts/opensans-bolditalic/opensans-bolditalic.ttf
// module chunks = index